export default [
    {
        name: 'blog',
        path: process.env.VUE_APP_BLOG_URL,
    },
];
